import React, { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Images } from "../components/layouts/Images";
import { processImages, initializeModel, getModelInfo } from "../../lib/process";
import Footer from "../components/layouts/Footer";
import FeaturedSection from "./FeaturedSection";
import BeforeAfterSlider from "./BeforeAfterSlider";
import BackgroundRemoverp2 from "./BackgroundRemoverp2";
import bannervedio from "./images/bannervedio.mp4"
import lineimage from "./images/lineimage.png"
import borderimge from "./images/borderimge.svg"
import { TiTick } from "react-icons/ti";
import HeroSection from "../components/layouts/Herosection";
import AdSenseAd from "../components/adds/AdsenseAd";
interface AppError {
    message: string;
}

export interface ImageFile {
    id: number;
    file: File;
    processedFile?: File;
}

// Sample images from Unsplash
const sampleImages = [
    "https://images.unsplash.com/photo-1601233749202-95d04d5b3c00?q=80&w=2938&auto=format&fit=crop&ixlib=rb-4.0.3",
    "https://images.unsplash.com/photo-1513013156887-d2bf241c8c82?q=80&w=2970&auto=format&fit=crop&ixlib=rb-4.0.3",
    "https://images.unsplash.com/photo-1643490745745-e8ca9a3a1c90?q=80&w=2874&auto=format&fit=crop&ixlib=rb-4.0.3",
    "https://images.unsplash.com/photo-1574158622682-e40e69881006?q=80&w=2333&auto=format&fit=crop&ixlib=rb-4.0.3"
];

// Check if the user is on mobile Safari
// const isMobileSafari = () => {
//     const ua = window.navigator.userAgent;
//     const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
//     const webkit = !!ua.match(/WebKit/i);
//     const iOSSafari = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/OPiOS/i) && !ua.match(/FxiOS/i);
//     return iOSSafari && 'ontouchend' in document;
// };

export default function Home() {
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<AppError | null>(null);
    const [isWebGPU, setIsWebGPU] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [currentModel, setCurrentModel] = useState<'briaai/RMBG-1.4' | 'Xenova/modnet'>('briaai/RMBG-1.4');
    const [isModelSwitching, setIsModelSwitching] = useState(false);
    const [images, setImages] = useState<ImageFile[]>([]);

    // useEffect(() => {
    //     if (isMobileSafari()) {
    //         window.location.href = 'https://bg-mobile.addy.ie';
    //         return;
    //     }

    //     // Only check iOS on load since that won't change
    //     const { isIOS: isIOSDevice } = getModelInfo();
    //     setIsIOS(isIOSDevice);
    //     setIsLoading(false);
    // }, []);

    // const handleModelChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    //     const newModel = event.target.value as typeof currentModel;
    //     setIsModelSwitching(true);
    //     setError(null);
    //     try {
    //         const initialized = await initializeModel(newModel);
    //         if (!initialized) {
    //             throw new Error("Failed to initialize new model");
    //         }
    //         setCurrentModel(newModel);
    //     } catch (err) {
    //         if (err instanceof Error && err.message.includes("Falling back")) {
    //             setCurrentModel('briaai/RMBG-1.4');
    //         } else {
    //             setError({
    //                 message: err instanceof Error ? err.message : "Failed to switch models"
    //             });
    //         }
    //     } finally {
    //         setIsModelSwitching(false);
    //     }
    // };

    // const onDrop = useCallback(async (acceptedFiles: File[]) => {
    //     const newImages = acceptedFiles.map((file, index) => ({
    //         id: Date.now() + index,
    //         file,
    //         processedFile: undefined
    //     }));
    //     setImages(prev => [...prev, ...newImages]);

    //     // Initialize model if this is the first image
    //     if (images.length === 0) {
    //         setIsLoading(true);
    //         setError(null);
    //         try {
    //             const initialized = await initializeModel();
    //             if (!initialized) {
    //                 throw new Error("Failed to initialize background removal model");
    //             }
    //             // Update WebGPU support status after model initialization
    //             const { isWebGPUSupported } = getModelInfo();
    //             setIsWebGPU(isWebGPUSupported);
    //         } catch (err) {
    //             setError({
    //                 message: err instanceof Error ? err.message : "An unknown error occurred"
    //             });
    //             setImages([]); // Clear the newly added images if model fails to load
    //             setIsLoading(false);
    //             return;
    //         }
    //         setIsLoading(false);
    //     }

    //     for (const image of newImages) {
    //         try {
    //             const result = await processImages([image.file]);
    //             if (result && result.length > 0) {
    //                 setImages(prev => prev.map(img =>
    //                     img.id === image.id
    //                         ? { ...img, processedFile: result[0] }
    //                         : img
    //                 ));
    //             }
    //         } catch (error) {
    //             console.error('Error processing image:', error);
    //         }
    //     }
    // }, [images.length]);

    const onDrop = useCallback(
        async (acceptedFiles: File[]) => {
            if (images.length >= 5) {
                alert("You exceeded your 5 file limit. Refresh the page to add new images.");
                return;
            }

            // Filter if some files would exceed limit
            const availableSlots = 5 - images.length;
            const filesToAdd = acceptedFiles.slice(0, availableSlots);

            const newImages = filesToAdd.map((file, index) => ({
                id: Date.now() + index,
                file,
                processedFile: undefined
            }));

            setImages(prev => [...prev, ...newImages]);

            if (images.length === 0 && newImages.length > 0) {
                setIsLoading(true);
                setError(null);
                try {
                    const initialized = await initializeModel();
                    if (!initialized) {
                        throw new Error("Failed to initialize background removal model");
                    }
                    const { isWebGPUSupported } = getModelInfo();
                    setIsWebGPU(isWebGPUSupported);
                } catch (err) {
                    setError({
                        message: err instanceof Error ? err.message : "An unknown error occurred"
                    });
                    setImages([]);
                    setIsLoading(false);
                    return;
                }
                setIsLoading(false);
            }

            for (const image of newImages) {
                try {
                    const result = await processImages([image.file]);
                    if (result && result.length > 0) {
                        setImages(prev =>
                            prev.map(img =>
                                img.id === image.id
                                    ? { ...img, processedFile: result[0] }
                                    : img
                            )
                        );
                    }
                } catch (error) {
                    console.error('Error processing image:', error);
                }
            }
        },
        [images.length]
    );


    const handlePaste = async (event: React.ClipboardEvent) => {
        const clipboardItems = event.clipboardData.items;
        const imageFiles: File[] = [];
        for (const item of clipboardItems) {
            if (item.type.startsWith("image")) {
                const file = item.getAsFile();
                if (file) {
                    imageFiles.push(file);
                }
            }
        }
        if (imageFiles.length > 0) {
            onDrop(imageFiles);
        }
    };

    // const handleSampleImageClick = async (url: string) => {
    //     try {
    //         const response = await fetch(url);
    //         const blob = await response.blob();
    //         const file = new File([blob], 'sample-image.jpg', { type: 'image/jpeg' });
    //         onDrop([file]);
    //     } catch (error) {
    //         console.error('Error loading sample image:', error);
    //     }
    // };

    const handleSampleImageClick = async (url: string) => {
        if (images.length >= 5) {
            alert("You exceeded your 5 file limit. Refresh the page to add new images.");
            return;
        }

        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const file = new File([blob], 'sample-image.jpg', { type: 'image/jpeg' });
            onDrop([file]);
        } catch (error) {
            console.error('Error loading sample image:', error);
        }
    };


    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        onDrop,
        accept: {
            "image/*": [".jpeg", ".jpg", ".png", ".mp4"],
        },
    });


    // const {
    //    getRootProps,
    //     getInputProps,
    //     isDragActive,
    //     isDragAccept,
    //     isDragReject,
    //     open,
    // } = useDropzone({
    //     onDrop,
    //     accept: {
    //         "image/*": [".jpeg", ".jpg", ".png", ".mp4"],
    //     },
    //     noClick: true,
    //     noKeyboard: true,
    //     disabled: images.length >= 5,
    // });

    // Remove the full screen error and loading states

    return (

        <>
            <HeroSection />
            <div className=" bg-[#fff] font-poppins" onPaste={handlePaste} >
                <div className={`relative bg-white flex flex-col  px-4 sm:px-8 ${images.length !== 0 ? "relative min-h-[750px] bg-white flex flex-col  pb-[4rem] px-4 sm:px-8 " : "py-10"}`}>
                    {/* Yellow squiggles */}
                    {/* <div className="flex justify-center items-center">  </div> */}

                    {/* <div className={`absolute text-[124px] rotate-45 z-0 ${images.length !== 0 ? " hidden " : "top-[2rem] right-[10rem] hidden xl:block"}`}>〰️</div>
                    <div className={`absolute  -rotate-12 z-0 ${images.length !== 0 ? " hidden  " : "bottom-[1rem] left-[1rem] hidden xl:block"}`}><img src={lineimage} alt="" />  </div> */}

                    {/* Main content */}
                    {/* {images.length !== 0 && (
                        <div className="font-display font-bold text-center text-2xl sm:text-3xl md:text-3xl max-w-5xl mx-auto mt-5 mb-2 px-8 sm:px-6 md:px-52 text-typo">
                            Upload an image to remove the background
                        </div>
                    )} */}
                    <div className={`grid grid-cols-1  gap-12 items-center relative z-10 max-w-5xl mx-auto md:grid-cols-2 `}>
                        {/* Left: Hero */}
                        {/* {images.length === 0 && ( */}
                        <div className="text-center md:text-left flex flex-col items-center md:items-start">
                            <div className="relative">
                                <video
                                    src={bannervedio}
                                    autoPlay
                                    // loop
                                    muted
                                    playsInline
                                    controls={false}
                                    controlsList="nodownload nofullscreen noremoteplayback"
                                    disablePictureInPicture
                                    onContextMenu={(e) => e.preventDefault()} // 🔒 disables right click
                                    className="relative z-10 w-[23rem] h-[580px] md:w-[100%] rounded-lg object-cover"
                                />

                            </div>

                            {/* <h1 className="font-display font-bold mt-3 text-typo m-0 text-4xl md:text-5xl lg:text-6xl text-center md:!text-left">
                                    Remove Image <br /> Background
                                </h1>
                                <p className="text-typo-tertiary font-bold text-xl m-0 mt-4 !text-typo text-center md:!text-left">
                                    100% Automatically and
                                    <span className="bg-yellow-300 px-2 py-0.5 rounded font-semibold ml-1 text-gray-800">
                                        Free
                                    </span>
                                </p> */}
                        </div>
                        {/* )} */}


                        {/* Right: Upload box */}
                        <div className="flex flex-col justify-center w-full px-4">
                            <div className="bg-white glowing-card  rounded-3xl shadow-2xl  w-full max-w-lg text-center">
                                <div
                                    style={{
                                        backgroundImage: `url(${borderimge})`,
                                        backgroundSize: 'calc(100% - -0px) 100%',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center',
                                        padding: "20px"

                                    }}
                                    {...getRootProps()}
                                    className="rounded-2xl lg:p-4 flex flex-col items-center justify-center cursor-pointer transition hover:border-[#645ade]"
                                >
                                    <input
                                        {...getInputProps()}
                                        disabled={isLoading || isModelSwitching || images.length >= 5}
                                    />

                                    {/* Main text */}
                                    <h2 className="text-[15px] lg:text-2xl font-poppins font-bold pt-[10px] pb-[7px] px-4 text-[#242424] mb-4">
                                        Drag and drop an image{" "}
                                        <span className="text-[#645ade] font-poppins font-bold">or browse to upload.</span>
                                    </h2>

                                    {/* Upload button */}
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (images.length >= 5) {
                                                alert("You exceeded your 5 file limit. Refresh the page to add new images.");
                                            }
                                        }}
                                        className="bg-[#4646c6] font-poppins hover:bg-[#5050de] text-white font-semibold text-[12px] lg:text-lg px-6 py-3 rounded-full shadow mb-2 transition"
                                    >
                                        Upload your photo
                                    </button>

                                    {/* File requirements text */}
                                    <p className="text-[10px]  font-poppins text-[#242424] font-semibold mb-3">
                                        File must be JPEG, JPG, PNG or WebP and up to 40MB
                                    </p>

                                    {/* Badges */}
                                    <div className="flex flex-col md:flex-row gap-2 md:gap-4 justify-center items-center text-sm text-[#f06dad] font-medium">
                                        <div className="flex items-center font-poppins gap-1">
                                            <span className="bg-[#f06dad] font-poppins rounded-full text-white p-[0.5px]"><TiTick /></span> Free to use
                                        </div>
                                        <div className="flex items-center font-poppins gap-1">
                                            <span className="bg-[#f06dad] font-poppins rounded-full text-white p-[0.5px]"><TiTick /></span> No credit card required
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="mt-[5.5rem] text-center relative z-10">

                                <p className="text-[#242424] font-poppins font-semibold mb-4">No image? Try one of these:</p>
                                <div className="flex justify-center gap-4 flex-wrap">
                                    {sampleImages.map((url, index) => (
                                        <button
                                            key={index}
                                            onClick={() => handleSampleImageClick(url)}
                                            className="w-20 h-20 rounded-lg overflow-hidden shadow hover:opacity-80 transition"
                                        >
                                            <img
                                                src={url}
                                                alt={`Sample ${index + 1}`}
                                                className="w-full h-full object-cover"
                                            />
                                        </button>
                                    ))}
                                </div>
                                <p className="text-[12px] font-poppins text-[#242424] mt-6 max-w-lg mx-auto px-2">
                                    By uploading an image or URL you agree to our <a href="#" className="underline font-semibold text-[#3b63fb]">Terms of Service</a>. To learn more about how we handle your personal data, check our <a href="#" className="underline font-semibold text-[#3b63fb]">Privacy Policy</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* Sample Images + Terms */}
                    {/* {images.length === 0 && ( */}
                    {/* )} */}
                </div>
            </div>
            {images.length !== 0 && (
                <div className="flex flex-col justify-center items-center text-center">
                    <h1 className="text-3xl font-poppins md:text-5xl font-extrabold text-[#242424] mb-4">
                        A BG remover for every occasion

                    </h1 >
                    <p className="px-4 lg:px-72 font-poppins font-medium mb-6">
                        Whether you're editing product photos, a LinkedIn portrait, or creating a fun car edit,  Bgremoverr.cloud Background Remover can handle it all.
                    </p>
                </div>
            )
            }
            <div className="mt-16 mb-24"><Images images={images} onDelete={(id) => setImages(prev => prev.filter(img => img.id !== id))} /></div>
            <div className="mb-9 mt-11  "> <BeforeAfterSlider /></div>
            <div className="mb-2 mt-5"><BackgroundRemoverp2 /></div>
            <div className=""><FeaturedSection /></div>
            {/* <AdSenseAd /> */}
            <Footer />
        </>
    );
}
